import { useCallback, useMemo } from "react";
import "./styles/Main.css";
import useAuthStore, { getDisplayName } from "./states/authStore";
import { logout } from "./services/authApi";
import useIsSmallScreen from "./hooks/useIsSmallScreen";
import { Link } from "react-router-dom";
import {
    AnimatedReveal, PageHeader, NavBar, Page, NavigationItem,
    createAppCatalog, filterAppCatalog, DEFAULT_ENABLED_APP_IDS,
} from "@iq/models";
import AppUserMenu from "./components/AppUserMenu";

const HOME_LINK = { to: "/" };
const APP_CATALOG = createAppCatalog({
    calendar: process.env.REACT_APP_CALENDAR_APP_URL,
    service: process.env.REACT_APP_SERVICE_APP_URL || process.env.REACT_APP_SERVICE_API_URL,
    store: process.env.REACT_APP_STORE_APP_URL,
    studio: process.env.REACT_APP_STUDIO_APP_URL,
    admin: process.env.REACT_APP_ADMIN_APP_URL,
});

function Main({ enabledAppIds = DEFAULT_ENABLED_APP_IDS }){

    const profile = useAuthStore((state) => state.profile);
    const organizationName = useAuthStore((state) => state.organizationName);
    const role = useAuthStore((state) => state.role);
    const clearAuth = useAuthStore((state) => state.clearAuth);
    const isSmallScreen = useIsSmallScreen();

    const profileName = getDisplayName(profile) || "User";
    const profileId = profile?.id ?? null;

    const handleLogout = useCallback(async () => {
        try {
            await logout();
        } catch {
            // Clear client auth state even if the logout request fails.
        } finally {
            clearAuth();
            window.location.assign("/login-client");
        }
    }, [clearAuth]);

    const appLinks = useMemo(
        () => filterAppCatalog(APP_CATALOG, enabledAppIds),
        [enabledAppIds]
    );

    return(
            <div className={`crm-layout app${isSmallScreen ? " crm-layout-mobile" : ""}`}>
                {!isSmallScreen && (
                        <NavBar
                            activeId="home"
                            navItems={appLinks}
                            homeLink={HOME_LINK}
                            LinkComponent={Link}
                        />
                )}
                <PageHeader
                    title={organizationName || "Striver"}
                    apps={appLinks}
                    homeLink={HOME_LINK}
                    activeId="home"
                    LinkComponent={Link}
                    isSmallScreen={isSmallScreen}
                    logoutAction={{ onClick: handleLogout }}
                    user={{ name: profileName }}
                    userMenu={
                        <AppUserMenu name={profileName} id={profileId} />
                    }
                />
                <Page>
                    <AnimatedReveal
                        stagger={100}
                    >
                        <div className="app-main-content">
                            <div className="main-panel-title-container">
                                <h2 className="main-panel-welcome" data-reveal>Welcome back,</h2>
                                <h2 className="main-panel-profile-name" data-reveal>{profileName}</h2>
                            </div>
                            <h2 className="main-panel-title">- Your Apps -</h2>
                            <div className="main-panel-grid">
                                {appLinks.map((app) => {
                                    const AppImage = app.image;
                                    return (
                                        <div key={app.id} className="main-panel-grid-item" data-reveal>
                                            <NavigationItem
                                                item={app}
                                                LinkComponent={Link}
                                                className="main-app-link"
                                            >
                                                <AppImage
                                                    role="img"
                                                    aria-label={app.label}
                                                    className="main-app-link-image"
                                                />
                                            </NavigationItem>
                                            <p className="main-app-link-text">{app.label}</p>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {role === 'superAdmin' && (
                            <button onClick={() => window.location.href = "/troubleshoot"}>Clients troubleshooting station </button>
                        )}

                        <div className="main-panel-spacer" aria-hidden="true" />
                    </AnimatedReveal>
                </Page>
            </div>
    )
}

export default Main